module.exports = __webpack_public_path__ + "img/bg-sect-4.2b0bdde7.png";